<template>
    <div class="atosic-upload">
        <div class="sound-needed-alert" v-show="showSoundAlert">
            <span class="closebtn" @click="showSoundAlert=false" >&times;</span>
            {{ getTranslation('lbl_sounds_needed' )}}
        </div>
        <div class="el-upload-dragger" :class="{'is-dragover': dragOver}">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
                <!--Drop files here or <em>click to upload</em>-->
                {{ getTranslation('lbl_upload_drop_file') }} <em>{{ getTranslation('lbl_upload_click_upload') }}</em>
            </div>
            <div class="inputs">
                <input
                        v-for="(input, index) in inputs"
                        class="transparent-input"
                        :class="inputClass(index)"
                        type="file"
                        :ref="input"
                        @change="updateFiles"
                        @dragover="dragOver = true"
                        @dragleave="dragOver = false"
                        @drop="dropFile"
                        multiple>
            </div>
        </div>
        <!--<div class="el-upload__tip">Select On Duty, Off Duty, Disturb, Help, Accepted, Denied and Invalid sound files.
            Allowed formats are wav/mp3/ogg/m4a, maximum file size 10 MB.</div>-->
        <div class="el-upload__tip">{{ getTranslation('lbl_upload_tip') }}</div>
        <ul class="el-upload-list el-upload-list--text">
            <li class="el-upload-list__item" :class="'is-' + status" v-for="(tempFile, index) in tempFiles">
                <a class="el-upload-list__item-name">
                    <i class="el-icon-document"></i>
                    {{ tempFile.fileObject.name }}
                    <span class="el-upload-list__item-size">
                        ({{ tempFile.fileObject.file.size || tempFile.fileObject.file.byteLength | convertBytes }})
                    </span>
                </a>
                <select class="form-control file-field-select" v-model="tempFile.fileField" @change="changeFileType">
                    <option value="">{{ getTranslation('lbl_upload_select_file_type') }}</option>
                    <option
                            v-for="field in fileFields"
                            v-if="showDropdownOption(field, index)"
                            :label="field.label"
                            :value="field.value"> {{field.label}}</option>
                </select>
                <label class="el-upload-list__item-status-label">
                    <i class="el-icon-circle-check"></i>
                    <i class="el-icon-close" @click="removeFile(index)"></i>
                    <i class="icon-spin fa fa-spinner fa-spin"></i>
                </label>
            </li>
        </ul>
        <button
                class="btn btn-success upload-button"
                ref="submit"
                v-show="!autoUpload"
                :disabled="uploadDisabled"
                @click="setFiles">{{ getTranslation('lbl_upload_upload') }}</button>
        <button
                class="btn btn-danger upload-button"
                ref="removeall"
                @click.prevent="removeFiles">{{ getTranslation('lbl_upload_clear_files') }}</button>

    </div>
</template>

<script>
    import { mainEventBus } from '../../../../main';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin';

    export default {
        props: ['autoUpload'],
        mixins: [
            translationMixin
        ],
        data: function() {
            return {
                dragOver: false,
                status: 'ready',
                tempFiles: [],
                fileFields: [],
                allowedFormats: ['wav', 'mp3', 'ogg', 'm4a'],
                maxFileSize: 10000000,
                inputs: [ 'input0' ],
                showSoundAlert:true
            }
        },
        computed: {
            uploadDisabled: function() {
                return this.tempFiles.length == 0;
            },
            maxFileNumber: function() {
                return this.fileFields.length;
            }
        },
        watch: {
            translations: function() {
                this.fileFields = [
                    {
                        label: this.getTranslation('lbl_client_onDutyFile'),
                        value: 'onDutyFile',
                        fileObject: {}
                    },
                    {
                        label: this.getTranslation('lbl_client_offDutyFile'),
                        value: 'offDutyFile',
                        fileObject: {}
                    },
                    {
                        label: this.getTranslation('lbl_client_disturbFile'),
                        value: 'disturbFile',
                        fileObject: {}
                    },
                    {
                        label: this.getTranslation('lbl_client_helpFile'),
                        value: 'helpFile',
                        fileObject: {}
                    },
                    {
                        label: this.getTranslation('lbl_client_acceptedFile'),
                        value: 'acceptedFile',
                        fileObject: {}
                    },
                    {
                        label: this.getTranslation('lbl_client_deniedFile'),
                        value: 'deniedFile',
                        fileObject: {}
                    },
                    {
                        label: this.getTranslation('lbl_client_invalidFile'),
                        value: 'invalidFile',
                        fileObject: {}
                    },
                    {
                        label: this.getTranslation('lbl_client_inputCode'),
                        value: 'codeFile',
                        fileObject: {}
                    }
                ];
            }
        },
        filters: {
            convertBytes: function(value) {
                var units = ['B', 'kB', 'MB', 'GB', 'TB'];
                var numOfOperations = 0;

                while (value > 1000) {
                    value = parseInt(value / 1000);
                    numOfOperations++;
                }

                return value + ' ' + units[numOfOperations];
            }
        },
        methods: {
            updateFiles: function(event) {
                var checkFiles = this.checkFiles(event.target.files);

                if (checkFiles.error) {
                    this.$refs['input' + (this.inputs.length - 1)].value = '';

                    if (checkFiles.type == 'format')
                        mainEventBus.$emit( 'alert', { type: 'warning', msg: 'error_wrong_file_format' } );
                    else if (checkFiles.type == 'size')
                        mainEventBus.$emit( 'alert', { type: 'warning', msg: 'error_max_file_size_exceeded' } );
                    else
                        mainEventBus.$emit( 'alert', { type: 'warning', msg: 'error_max_file_number_exceeded' } );
                }
                else {
                    for (var i = 0; i < event.target.files.length; i++) {
                        this.tempFiles.push({
                            fileField: '',
                            fileObject: {
                                file: event.target.files[i],
                                name: event.target.files[i].name
                            }
                        });
                    }
                    this.inputs.unshift();
                    this.inputs.push('input' + this.inputs.length);

                    if (this.autoUpload)
                        this.setFiles();

                    this.$emit('tempFiles', this.tempFiles);
                }
            },
            removeFile: function(index) {
                this.tempFiles.splice(index, 1);

                this.setFileFields();

                if (this.autoUpload)
                    this.setFiles();
            },
            removeFiles: function() {
                this.tempFiles = [];

                /* Loop over inputs fields and removes them from the DOM */
//
//                if(this.inputs.length > 1){
//                    for(var i = 0;i<this.inputs.length-1;i++){
//                        this.inputs.splice(i,1);
//                    }
//                }

                this.setFileFields();

                if (this.autoUpload)
                    this.setFiles();
                this.$emit('tempFiles', this.tempFiles);
            },
            setFiles: function() {
                this.$emit('setFiles', this.fileFields);
            },
            dropFile: function() {
                this.dragOver = false;
            },
            inputClass: function(index) {
                if (index == this.inputs.length - 1)
                    return '';
                else
                    return 'invisible';
            },
            changeFileType: function(event, file) {
                this.setFileFields();

                if (this.autoUpload)
                    this.setFiles();
            },
            setFileFields: function() {
                for (var i = 0; i < this.fileFields.length; i++) {
                    var file = this.tempFiles.find(function (element) {
                        return element.fileField == this.fileFields[i].value;
                    }.bind(this));
                    if (file) {
                        this.fileFields[i].fileObject = file.fileObject;
                        file.fileField = this.fileFields[i].value;
                    }
                    else
                        this.fileFields[i].fileObject = {};
                }
            },
            checkFiles: function(files) {
                var checkObject = { error: true, type: '' };

                if (this.tempFiles.length + files.length > this.maxFileNumber) {
                    checkObject.type = 'number';
                    return checkObject;
                }

                for (var i = 0; i < files.length; i++) {
                    var fileName = files[i].name.split('.');
                    var formatOk = false;

                    for (var j = 0; j < this.allowedFormats.length; j++)
                        if (fileName[fileName.length - 1] == this.allowedFormats[j])
                            formatOk = true;

                    if (!formatOk) {
                        checkObject.type = 'format';
                        return checkObject;
                    }

                    if (files[i].size > this.maxFileSize) {
                        checkObject.type = 'size';
                        return checkObject;
                    }
                }

                checkObject.error = false;
                return checkObject;
            },
            showDropdownOption: function(field, fileIndex) {
                return !field.fileObject.file || this.tempFiles[fileIndex].fileField == field.value;
            }
        }
    }
</script>

<style scoped>

    .sound-needed-alert{
        padding: 10px;
        background-color: #243863;
        color: white;
        margin-bottom: 15px;
    }

    .sound-needed-alert .closebtn {
        margin-left: 15px;
        color: white;
        font-weight: bold;
        float: right;
        font-size: 22px;
        line-height: 20px;
        cursor: pointer;
        transition: 0.3s;
    }

    .sound-needed-alert .closebtn:hover {
        color: black;
    }

</style>


// WEBPACK FOOTER //
// Upload.vue?40be3da4